import React, { useState } from "react";
import { Modal, Button, TextAreaInput } from '@prosolve/common-components-ui'
import useDataEvents from "../../../../dataHooks/useDataEvents";

export default ({
  eventData,
  onClose,
  onSuccess,
}) => {
  const {
    id,
    scheduleNotes: scheduleNotesParam
  } = eventData || {}

  const { isLoading, updateEventScheduleNotes } = useDataEvents()

  const [scheduleNotes, setScheduleNotes] = useState(scheduleNotesParam)

  const onClickSubmit = async () => {
    await updateEventScheduleNotes({
      id,
      scheduleNotes
    })
    onSuccess?.()
    onClose?.()
  }

  return (
    <Modal title='Schedule Notes' isAutoHeight={true} isAutoWidth={true} onClose={onClose} footer={(
      <div style={{ 
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        columnGap: '10px',
        padding: '10px'
      }}>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onClickSubmit} $colored={true} $disabled={isLoading}>
          Submit
        </Button>
      </div>
    )}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px',
        height: '100%',
        position: 'relative'
      }}>
        <div style={{ fontWeight: 'bold' }}>Note: Schedule notes will be used in place of any scheduled sessions if provided.</div>
        <div>Schedule Notes:</div>
        <TextAreaInput
          //fieldId='scheduleNotes'
          //type='text'
          //label='Schedule Notes'
          placeholder=''
          //formData={formData}
          value={scheduleNotes}
          onChange={setScheduleNotes}
        />
      </div>
    </Modal>
  )
}